'use client'

import { CaretLeftIcon } from '@phosphor-icons/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ROUTES } from '@/core/constants/routes';
import { formatDateTime } from '@/core/utils/time';

function BreadCrumb() {
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;
  const navigate = useNavigate();

  const goBack = useCallback(() => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  }, [navigate]);

  const header = () => {
    return t(`sidebar.${ROUTES.find((item) => item.route.includes(pathname))?.name || "summary"}`)
  }

  return (
    <section className={`bread-crumb`}>
      <div className="d-flex align-items-center gap-2 bread-crumb__back">
        {
          pathname !== '/' && (
            <CaretLeftIcon onClick={goBack} size={21} style={{ color: 'var(--text-primary)' }} />
          )
        }
        <h1 className="heading3">{header()}</h1>
      </div>
      <p className="subheading3">{formatDateTime(new Date(), false, false)}</p>
    </section>
  )
}

export default BreadCrumb
